<template>
  <b-row class="fields-data-review">
    <template v-for="(field, i) in data">
      <template v-if="hideEmptyFields ? field.value : true">
        <b-col :key="field.label + i" class="row-6">
          <p class="label mb-1">{{ field.label }}</p>
          <p class="value">{{ field.value }}</p>
        </b-col>
        <div :key="i" v-if="stackUI || (i + 1) % 2 === 0" class="w-100"></div>
      </template>
    </template>
  </b-row>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: false,
      default: () => []
    },
    stackUI: {
      type: Boolean,
      required: false,
      default: false
    },
    hideEmptyFields: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.fields-data-review {
  font-weight: 400;
  .label {
    font-size: 1rem;
    color: $secondary;
  }
  .value {
    font-size: 1.125rem;
  }
}
</style>
